module.exports = __webpack_public_path__ + "catalog/holes/sliding-door/slidingdoor1.png";